module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-00.1.215bdb4e.jpg";